var _rect, _path, _path2, _rect2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNothingSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 153,
  height: 94,
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44.764,
  height: 27.037,
  fill: "#BCCEF5",
  rx: 3,
  transform: "rotate(7.824 50.051 731.962)skewX(.014)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m167.473 9.257-72.948 31.4 67.372 9.256z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m100.103 0 61.215 49.833-66.79-9.177z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.5,
  d: "M160.448 48.904 130.76 24.888l2.619-.873z",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 60.376,
  height: 36.466,
  fill: "#BCCEF5",
  rx: 3,
  transform: "matrix(-.9907 .13612 .13588 .99073 60.262 8.63)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m-30.608 21.116 98.388 42.35-90.867 12.485z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m60.26 8.63-82.563 67.213 90.084-12.378-7.52-54.835Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.5,
  d: "M-21.131 74.59 18.91 42.199l-3.533-1.178-36.51 33.569Z",
  style: {
    mixBlendMode: "overlay"
  }
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E9EFFC",
  d: "m125.299 34.642-50.263 35.11-50.262-35.11L70.785 2.49a7.43 7.43 0 0 1 8.507 0l9.178 6.423 2.403 1.67 24.197 16.912 2.549 1.79z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "M66.864 64.043 24.774 94V34.642zm16.348 0L125.3 94V34.642L83.21 64.043Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m24.774 94 45.957-32.704a7.42 7.42 0 0 1 8.615 0L125.299 94z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F8FF",
  d: "M124.436 49.473c9.344 4.374 21.979 7.545 28.116 8.569-1.389 3.23-27.358 27.383-38.999 32.116-.792.122-19.082-8.394-29.119-14.234.341.487 26.441-13.276 40.002-26.451"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "M122.305 56.493c.43-.299.975-.38 1.474-.218l16.346 5.293a.87.87 0 0 1 .4 1.385 1.195 1.195 0 0 1-1.306.366l-16.763-5.747a.61.61 0 0 1-.151-1.079m-4.581 4.357c.415-.39 1.01-.52 1.55-.338l11.315 3.812c.5.168.676.785.342 1.191a1.03 1.03 0 0 1-1.132.322l-11.871-4.046a.562.562 0 0 1-.204-.94Zm-4.697 3.618a1.59 1.59 0 0 1 1.536-.253l13.035 4.742a.758.758 0 0 1 .293 1.232 1.04 1.04 0 0 1-1.117.263l-13.585-4.99a.579.579 0 0 1-.162-.994m-10.591 7.237a1.45 1.45 0 0 1 1.592-.382l7.448 2.845a.742.742 0 0 1 .333 1.133c-.273.37-.759.51-1.187.344l-7.985-3.095a.528.528 0 0 1-.201-.845m4.864-3.865a1.68 1.68 0 0 1 1.475-.156l17.164 6.282a.77.77 0 0 1 .242 1.301c-.291.255-.698.33-1.061.196l-17.706-6.529a.613.613 0 0 1-.114-1.095Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44.764,
  height: 27.037,
  fill: "#fff",
  rx: 3,
  transform: "rotate(7.824 50.051 731.962)skewX(.014)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60.376,
  height: 36.466,
  fill: "#fff",
  rx: 3,
  transform: "matrix(-.9907 .13612 .13588 .99073 60.262 8.63)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  width: 106.608,
  height: 74.683,
  x: 21.732,
  y: 1.152,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.042
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.521
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6656_53657"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6656_53657",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNothingSelected);
export default ForwardRef;